<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <div class="btnAdd">
        <el-button
          :size="subUnitSize"
          type="primary"
          icon="el-icon-plus"
          @click="showEdit"
          >创建主体</el-button
        >
      </div>
    </div>
    <VTable
      has-pagionation
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :tree-props="{ children: 'children', hasChildren: 'has_child' }"
      :hasPagionation="true"
      :default-expand-all="true"
      :showSelect="false"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:business_license="{ row }">
        <el-image
           style="width: 100px; height: 100px;"
          :src="row.business_license"
          fit="cover"
          :preview-src-list="[row.business_license]"
        ></el-image>
      </template>
      <template v-slot:merchant_count="{ row }">
        <el-button type="text" @click="editCount(row)">{{
          row.merchant_count
        }}</el-button>
      </template>
    </VTable>

    <!-- 编辑 -->
    <edit ref="edit" @refresh="getTable"></edit>
    <addZhuti ref="addZhutiRef" @refresh="getTable"></addZhuti>
  </div>
</template>

<script>
import Edit from "./components/Edit.vue";
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import addZhuti from "./components/addZhuti.vue";
export default {
  name: "Sortingsource",
  components: {
    Edit,
    VTable,
    addZhuti,
  },
  mixins: [mixinTable],
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "name", label: "分拣标签供应商", hidden: false },
        { name: "business_license", label: "营业执照", hidden: false },
        { name: "merchant_count", label: "客户数", hidden: false },
        { name: "update_time", label: "更新时间", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          page: 1,
          count: 20,
        },
        data: [],
        total: 0,
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    showEdit() {
      let dom = this.$refs.addZhutiRef;
      dom.toggle(true);
      dom = null;
    },
    getTable() {
      this.table.loading = true;
      this.$http
        .get("/admin/source/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        });
    },
    // 新增、编辑
    editCount(row) {
      let dom = this.$refs.edit;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
  },
};
</script>
